import { useEffect, useRef, useState } from "react";

import { useHydrateCustomerTopPriority } from "@/hooks/mutations/useHydrateCustomerTopPriority";
import { HydrateCustomerTopPriorityResponse } from "@/types";

// Hydrates "customer top priority" summaries for user ids as they appear,
// requesting each id at most once and accumulating the results.
export const useCustomerTopPrioritySummaries = (
  jobId: string,
  userIds: number[],
  isEnabled: boolean,
) => {
  const hydratedUserIdsRef = useRef(new Set<number>());
  const [userIdToSummary, setUserIdToSummary] =
    useState<HydrateCustomerTopPriorityResponse>({});

  const { isPending, mutate: hydrateCustomerTopPriority } =
    useHydrateCustomerTopPriority();

  useEffect(() => {
    if (!isEnabled) {
      return;
    }
    const newUserIds = userIds.filter(
      (userId) => !hydratedUserIdsRef.current.has(userId),
    );
    if (!newUserIds.length) {
      return;
    }

    newUserIds.forEach((userId) => {
      hydratedUserIdsRef.current.add(userId);
    });
    hydrateCustomerTopPriority(
      { jobId, userIds: newUserIds },
      {
        onSuccess: (summary) => {
          setUserIdToSummary((currentSummary) => ({
            ...currentSummary,
            ...summary,
          }));
        },
      },
    );
  }, [hydrateCustomerTopPriority, isEnabled, jobId, userIds]);

  return { isPending, userIdToSummary };
};
